import React, { useState } from 'react';
import { Input } from './Input';

interface DraftNumberInputProps {
  id?: string;
  label?: string;
  tooltip?: string;
  step?: number | string;
  value: number;
  className?: string;
  onValueChange: (raw: string) => void;
}

/**
 * A number input that holds a draft string while the user edits it.
 *
 * A plain controlled number input binds `value` to a derived number, so the box
 * snaps back to that number the instant it is emptied -- you can never delete
 * the last digit to retype the value. This keeps a local draft while editing so
 * the field can be cleared and a new number typed. On blur the draft is dropped
 * and the field resyncs to the committed value. The parent still receives the
 * raw string on every change and does its own parsing.
 */
export const DraftNumberInput: React.FC<DraftNumberInputProps> = ({
  value,
  onValueChange,
  step = 'any',
  ...rest
}) => {
  const [draft, setDraft] = useState<string | null>(null);
  return (
    <Input
      {...rest}
      type="number"
      step={step}
      value={draft !== null ? draft : value}
      onChange={(e) => {
        setDraft(e.target.value);
        onValueChange(e.target.value);
      }}
      onBlur={() => setDraft(null)}
    />
  );
};
